import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const uiCareRoutes = {
  [ERouteMappingKeys.UI_CARE]: {
    id: "ui-care",
    path: "/ui-care",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/UICare").then((p) => ({
          default: p.UICare,
        })),
      ),
    },
  },
};
